import { useEffect, useState } from "react";
import { SubTitlePage } from "../../../components/ui/SubTitlePage";
import { INews } from '../../../types/news';
import { api, urls } from '../../../services/api';
import { useApp } from '../../../context/App';
import brasao from '../../../assets/imgs/brasao.webp'

interface Props {
	idNews: string
	categorieNewsId: number
}

export function OtherNews({ idNews, categorieNewsId }: Props) {

	const [news, setNews] = useState<INews[]>([])
	const { configDomainURL } = useApp()
	const domain = configDomainURL

	function parseDate(date: string) {
		const dateSplit = date.split('/')
		if (dateSplit.length < 3) return date;

		const monthsOfYear = [
			'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
			'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
		]

		const day = dateSplit[0]
		const monthIndex = parseInt(dateSplit[1]) - 1
		const month = monthsOfYear[monthIndex]?.toUpperCase() || ''
		// Extract year, handling potential "- HH:MM" at the end
		const year = dateSplit[2].split(' ')[0]

		return `${day} ${month} ${year}`
	}

	const OtherNews_img_caminho = 'https://api-portal.itajai.sc.gov.br/public/portaladm-pmitajai/noticias/foto/'

	useEffect(() => {
		(async () => {

			try {

				const response = await api.get(urls.NewsByCategorie + categorieNewsId + '/cod_noticia_atual/' + idNews)
				setNews(response.data.noticias.slice(0, 4))
			} catch (error) {
				// silent
			}
		})()
	}, [categorieNewsId, idNews])

	return (
		<>
			{news.length > 0 && (
				<div className="w-full flex flex-col items-center justify-center mb-16 lg:mb-20">
					<SubTitlePage title="Noticias Relacionadas" />

					<div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4 mt-8 lg:mt-6">
						{news.map(item => (
							<a
								key={item.newsId}
								href={`${domain}noticias/${item.newsId}/${item.title.toLowerCase().replaceAll(' ', '-').replaceAll('/', '-').replaceAll(/[&/\\#,+()$~%.'":*?<>{}]/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")}`}
								className="group flex flex-col bg-white dark:bg-surface-dark-alt rounded-2xl lg:rounded-xl overflow-hidden shadow-sm hover:shadow-md dark:shadow-none dark:border dark:border-border-dark transition-all duration-300 hover:-translate-y-1"
							>
								<div className="relative w-full aspect-video overflow-hidden">
									{item.img ? (
										<img
											src={OtherNews_img_caminho + item.img}
											className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
											alt={item.title}
										/>
									) : (
										<div
											className="w-full h-full flex items-center justify-center bg-azul_itajai02 dark:bg-gray-800 bg-no-repeat bg-center bg-[length:auto_40%] transition-transform duration-500 group-hover:scale-105"
											style={{ backgroundImage: `url(${brasao})` }}
										/>
									)}
								</div>

								<div className="flex flex-col flex-1 p-5 lg:p-4">
									<h3 className="text-gray-900 dark:text-gray-100 font-bold text-lg lg:text-sm leading-snug line-clamp-3 mb-3 group-hover:text-primary dark:group-hover:text-primary-light transition-colors">
										{item.title}
									</h3>
									<div className="mt-auto">
										<span className="text-gray-500 dark:text-gray-400 font-medium text-sm lg:text-xs">
											{parseDate(item.published)}
										</span>
									</div>
								</div>
							</a>
						))}
					</div>
				</div>
			)}
		</>
	)

}